// @ts-check

import { functionalUpdate } from "@tanstack/react-table"
import { useState } from "react"
import {
  enforcePrimarySort,
  getSecondarySortValue,
} from "../../utils/tables/sorting.utils"

/**
 * @param {string} [primarySortId="date"]
 */

export function useTaskReportsSorting(primarySortId = "date") {
  const [sorting, setSorting] = useState([{ id: primarySortId, desc: false }])

  const enforceSort = enforcePrimarySort(primarySortId)

  /** @param {import("@tanstack/react-table").Updater<import("@tanstack/react-table").SortingState>} updater */
  const handleSortingChange = (updater) => {
    setSorting((prev) => enforceSort(functionalUpdate(updater, prev)))
  }

  /** @param {import("@tanstack/react-table").Table<any>} table */
  const getSortingValue = (table) =>
    getSecondarySortValue(table.getState().sorting, primarySortId)

  const resetSorting = () => setSorting([{ id: primarySortId, desc: false }])

  return { sorting, handleSortingChange, resetSorting, getSortingValue }
}
